// A friendly empty state: an illustration and one plain sentence (BRIEF.md section 1).
import type { ReactNode } from 'react';
import allSorted from './art/all-sorted.svg';
import receipts from './art/receipts.svg';

const ART = { 'all-sorted': allSorted, receipts } as const;

export function EmptyState({ art, children }: { art: keyof typeof ART; children: ReactNode }) {
  return (
    <div className="empty">
      <img src={ART[art]} alt="" width={160} height={128} />
      <div>{children}</div>
    </div>
  );
}
